<template>
  <div class="container">
    <label :class="{ 'checked': checked }">
      <input
        type="radio"
        :name="name"
        :value="value"
        :checked="checked"
        @click="$emit('click', value)"
      >
      <span class="checkmark" />
      <slot name="label">{{ label }}</slot>
    </label>
  </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    checked: {
      type: Boolean,
    },
  },
};
</script>
<style scoped>
.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  padding: 0;
}

label {
  flex-shrink: 1;
  font-family: Roboto, sans-serif;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  position: relative;
  padding-left: 32px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
  display: inline-block;
  margin: 0;
  color: #1b1b1b;
}

input {
  width: 0;
  height: 0;
}

label .checkmark {
  left: 0;
  top: 0;
  width: 24px;
  height: 24px;
  position: absolute;
  border: 1px solid #09292b;
  border-radius: 24px;
}

.checkmark::after {
  content: '';
  position: absolute;
  display: none;
}

label .checkmark::after {
  width: 12px;
  height: 12px;
  border-radius: 12px;
  top: 5px;
  left: 5px;
  background: #09292b;
}

label input:checked ~ .checkmark::after {
  display: block;
}
</style>
